/**
 * Pages whose address is itself the credential: anyone holding the link can act on it. Their URL must never be
 * handed to a third party, so marketing and analytics scripts are not loaded on them, and error reports are sent
 * with the token taken out.
 *
 * `public/index.html` repeats the page check inline for Google Tag Manager, which loads before the app does: keep
 * the two in step.
 */

/** Where a Box Truck agreement signing link opens. What follows it in the address is the link's token. */
export const AGREEMENT_SIGN_PATH = '/agreements/sign/'

export const isSecretLinkPage = (pathname: string = window.location.pathname): boolean => pathname.startsWith(AGREEMENT_SIGN_PATH)

/** A signing link's token wherever it sits in an address: after the page's path, or after the public API's. */
const SECRET_LINK_TOKEN = /(\/agreements\/sign\/|\/public\/agreements\/)[A-Za-z0-9_-]+/g

export const redactSecretLinks = (text: string): string => text.replace(SECRET_LINK_TOKEN, '$1[redacted]')
